import React, { useEffect } from 'react'

import { connect } from 'react-redux'
import {
  getTextoCookies,
  getTextoAceptar,
  getTextoRechazar
} from './modules/reducer'

//import 'gridlex/src/gridlex.scss'

import './gridlex.scss'
import './App.css'

import { Switch, Route, withRouter } from 'react-router-dom'
import useRouter from './components/Estancia/useRouter'

import { useTransition, animated } from 'react-spring'

import MiCookies, { gaPageview, gaInitialize } from './Cookies'
//import ReactGA from 'react-ga'

import MeasureHeight from './components/Images/MeasureHeight'
import Estancia from './components/Estancia/Estancia'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'
import OpcionesSeleccionadas from './components/Estancia/OpcionesSeleccionadas'
import FormUsuario from './components/Estancia/FormUsuario'
import Token from './components/Estancia/Token'
import OpcionesGuardadas from './components/Estancia/OpcionesGuardadas'

import IconLoading from './IconLoading'
import PdfLoading from './PdfLoading'

import CookieConsent from 'react-cookie-consent'

const HeaderR = withRouter(Header)
const OpcionesGuardadasR = withRouter(OpcionesGuardadas)

const App = ({
  loaded,
  token,
  heightHeader,
  gaId,
  idProyecto,
  textoCookies,
  textoAceptar,
  textoRechazar
}) => {
  gaPageview(window.location.hash.substring(1))

  const { location } = useRouter()

  useEffect(() => {
    function handleScroll(e) {
      e.preventDefault()
    }

    document.addEventListener('touchmove', handleScroll, { pasive: false })

    return function cleanup() {
      document.removeEventListener('touchmove', handleScroll, { pasive: false })
    }
  })

  const transitions = useTransition(location, location => location.pathname, {
    from: {
      /*opacity: 0 */
      transform: 'none' //'translate3d(0%,0,0)'
    },
    enter: {
      /*opacity: 1 */
      transform: 'none' //'translate3d(0%,0,0)'
    },
    leave: {
      //opacity: 1
      transform: 'none'
    },
    easing: t => t * t * t * t
  })

  const mq = window.matchMedia('(max-width: 414px)')

  let marginTop = 0

  if (mq.matches) {
    marginTop = heightHeader
  }

  return (
    <div className="App grid-column-noGutter">
      <HeaderR />
      {loaded ? (
        <div
          className="col-12 grid-noGutter"
          style={{ flex: 1, overflow: 'hidden-x', marginTop }}
        >
          <MeasureHeight />
          {transitions.map(({ item, props, key }) => (
            <animated.div
              key={key}
              className="col-12 grid-noGutter"
              style={props}
            >
              <Switch location={item}>
                <Route path="/token/:token" component={Token} />
                <Route path="/:idioma/:id" component={Estancia} />
                <Route path="/:idioma" component={Estancia} />
                <Route exact path="/" component={Estancia} />
                <Route component={Estancia} />
              </Switch>
            </animated.div>
          ))}
        </div>
      ) : (
        <IconLoading />
      )}
      <PdfLoading />
      {loaded ? <Footer /> : null}
      {loaded ? <OpcionesSeleccionadas /> : null}
      {loaded ? <FormUsuario /> : null}
      {token ? <OpcionesGuardadasR /> : null}
      {loaded ? (
        <CookieConsent
          cookieName={`CookieConsent${idProyecto}`}
          enableDeclineButton={true}
          buttonText={textoAceptar}
          declineButtonText={textoRechazar}
          onAccept={() => {
            gaInitialize(gaId)
          }}
        >
          {textoCookies}
        </CookieConsent>
      ) : null}
      {loaded ? <MiCookies /> : null}
    </div>
  )
}

const mapStateToProps = ({ reducer }, ownProps) => {
  return {
    loaded: reducer.loaded,
    token: reducer.token,
    generatePdf: reducer.generatePdf,
    heightHeader: reducer.heightHeader,
    gaId: reducer.gaId,
    idProyecto: reducer.idProyecto,
    textoCookies: getTextoCookies(reducer),
    textoAceptar: getTextoAceptar(reducer),
    textoRechazar: getTextoRechazar(reducer)
  }
}

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)
